<script>
  /** Specify the number of accordion items to render */
  // export let count = 4;

  /**
   * Specify alignment of accordion item chevron icon
   * @type {"start" | "end"}
   */
  export let align = "end";

  /**
   * Specify the size of the accordion
   * @type {boolean}
   */
  export let small = false;

  /** Set to `false` to close the first accordion item */
  export let open = true;

  /** Set to `true` to use paxbot style */
  export let paxbot = false;

  /** Specify the accordion width. */
  export let width = "100%";

  import SkeletonText from "../SkeletonText/SkeletonText.svelte";
  import AccordionChevron from "../icons/AccordionChevron.svelte";
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<div
  class:bx--skeleton="{true}"
  class:bx--accordion="{true}"
  class:bx--accordion--start="{align === 'start'}"
  class:bx--accordion--end="{align === 'end'}"
  class:bx--accordion--sm="{small}"
  class:bx--accordion--paxbot="{paxbot === true}"
  style:width="{width}"
  {...$$restProps}
>
  <div
    class:bx--accordion__item="{true}"
    class:bx--accordion__item--active="{open}"
  >
    <span class:bx--accordion__heading="{true}">
      <AccordionChevron class="bx--accordion__arrow" aria-label="loading" />
      <SkeletonText class="bx--accordion__title" />
    </span>
    {#if open}
      <div class:bx--accordion__content="{true}">
        <SkeletonText width="90%" />
        <SkeletonText width="80%" />
        <SkeletonText width="95%" />
      </div>
    {/if}
  </div>
</div>
